import React, { useEffect } from "react";
import { TransportationForm } from "./Forms/TransportationForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneTransportationQuery,
  useUpdateTransportationMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditTransportation = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: transportationResponse,
    isLoading,
    isFetching,
  } = useGetOneTransportationQuery({ id });
  const transportation = transportationResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateTransportation, isPending } = useUpdateTransportationMutation(setError);

  const onSubmit = (data) => {
    updateTransportation(data);
  };

  useEffect(() => {
    if (transportation) {
      reset(transportation);
    }
  }, [transportation, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_TRANSPORTATION")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <TransportationForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_TRANSPORTATION")}
                  </>
                ) : (
                  t("UPDATE_TRANSPORTATION")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

